import * as services from './ManagePools.services'
import {
  error
} from 'util';
import {
  fail
} from 'assert';
export default {
  data() {
    let context = this
    var validateLocationName = (rule, value, callback) => {
      if (context.addPool.PoolLocationName == "" && context.isnewLocation == true) {
        return callback(new Error('Please enter Facility Name'));
      } else
        callback();
    }
    var validPoolName = (rule, value, callback) => {
      if (context.addPool.PoolName == '') {
        return callback(new Error('Please enter a Name'));
      } else
        callback();
    }
  
    return {
      isadding: false,
      isShowallpools: true,
      locationList: [],
      isediting: false,
      isAddingOrEditing: "",
      poolTypes: [],
      UomList: [{
        Id: 1,
        Uom: "Feet"
      }, {
        Id: 2,
        Uom: "Yard"
      }, {
        Id: 3,
        Uom: "Meters"
      }],

      //FG - FOOF - 20200830-FG-0012 - BELOW
      VolumeUomList: [{
        Id: 1,
        Uom: "Gallons"
      }, {
        Id: 2,
        Uom: "Litres"
      }],
      //FG - FOOF - 20200830-FG-0012 - ABOVE

      TimeUoM: [{
        Id: 1,
        Uom: "Hours"
      }, {
        Id: 2,
        Uom: "Minutes"
      }],
      ShapeList: [{
        Id: 1,
        Shape: "Rectangle"
      }, {
        Id: 2,
        Shape: "Square"
      }, {
        Id: 3,
        Shape: "Round"
      }, {
        Id: 4,
        Shape: "Oval"
      }, {
        Id: 5,
        Shape: "Kidney"
      }, {
        Id: 6,
        Shape: "Freeform"
      }],
      addPool: {
        PoolName: '',
        PoolLocated: 'Indoor',
        PoolTypeDescription: '',
        PoolLanes: '',
        PoolStations: '',
        PoolShape: 'Rectangle',
        PoolVolume: '',
        PoolLength: '',
        PoolWidth: '',
        PoolLengthWidthUoM: 'Feet',
        PoolShalowMaxBathers: '',
        PoolDeepMaxBathers: '',
        PoolTotalMaxBathers: '',
        PoolMaxDepth: '',
        PoolMaxDepthUoM: '',
        PoolMinDepth: '',
        PoolMinDepthUoM: '',
        PoolVolume: '',
        PoolArea: '',
        PoolId: '',
        PoolPoolTypeId: '',
        PoolLocationId: '',
        PoolLocationName: '',
        PoolLocationAddress: '',
        PoolLocationPhoneNumber: '',
        PoolLocationFaxNumber: '',
        PoolVolumeUoM: '',
        PoolAreaUoM: '',
        PoolTurnOverTime: '',
        PoolTurnOverTime_Min: '',
        PoolTurnOverTime_Max: '',
        PoolInfluentPressure: '',
        PoolInfluentPressure_Min: '',
        PoolInfluentPressure_Max: '',
        PoolInfluentPressureUoM: 'PSI', //FG - FOOF - 20200730-FG-0010 - added 'PSI'so the value wouldn't be null or empty
        PoolEfluentPressure: '',
        PoolEfluentPressure_Min: '',
        PoolEfluentPressure_Max: '',
        PoolEfluentPressureUoM: 'PSI', //FG - FOOF - 20200730-FG-0011 - added 'PSI'so the value wouldn't be null or empty
        disabled: 'disabled',
        PoolTurnOverTime_UoM: '',
        PoolTurnOverPerDay: '',
        PoolTurnOverDayUoM: '',
        PoolCreatedOn: '',
        PoolUpdatedOn: '',
        UserName: '',
        OldUserName: '',
        PoolIsActive: '',
        PoolOpening: '',
        PoolClosing: '',
        SearchTag: '',
        PoolDescription: ''
      },
      rules: {
        PoolName: [{
          validator: validPoolName,
          trigger: 'blur'
        }],
        PoolLocationName: [{
          validator: validateLocationName,
          trigger: 'blur'
        }],
      },
      venueList: [],
      poolList: [],
      pooltypeId: '',
      poollocationId: '',
      locationId: '',
      locationName: '',
      isnewLocation: false,
      pools_columns: ['PoolName',
        'PoolLocationName', 'PoolTypeDescription', 'PoolShape', 'PoolVolume', 'PoolLength',
        'PoolWidth', 'PoolShalowMaxBathers', 'PoolDeepMaxBathers', 'PoolTotalMaxBathers', 'PoolMaxDepth', 'PoolMinDepth', 'PoolArea', 'Actions'
      ],
      sortable: [],
      optionstable: {
        headings: {
          PoolName: 'Venue Name',
          PoolLocationName: 'Facility',
          PoolTypeDescription: 'Type',
          PoolShape: 'Shape',
          PoolVolume: 'Volume',
          PoolLength: 'Length',
          PoolWidth: 'Width',
          PoolShalowMaxBathers: 'Shallow Max Bathers',
          PoolDeepMaxBathers: 'Deep Max Bathers',
          PoolTotalMaxBathers: 'Total Max Bathers',
          PoolMaxDepth: 'Max Depth',
          PoolMinDepth: 'Min Depth',
          PoolArea: 'Water Area',
          Actions: ''
        },

        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: ['IncidentDate'],
      },
    }
  },
  mounted() {
    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationId = data.LocationId ? data.LocationId : 0
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      var status = this.isShowallpools ? true : "";
      context.getPoolList(context.locationId, true);
    })
    this.getLocationList()
    this.getPoolTypes()
  },
  methods: {
    getPoolList(locid, status) {
      let context = this
      services.GetPoolList(status, locid).then(function (response) {

          context.poolList = []

          //Is this restricted ? -- FG - After Cert - First Release Security
          if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
            loader.stopLoader()
            return;
          }
          
          if (response != null) {
            context.poolList = response
          }
        }),
        (error) => {
        }
    },
    getLocationList() {
      let context = this
      services.GetLocationlist(true).then(function (response) {
        context.locationList = response
        context.poollocationId = context.locationList[0].LocationId
      }, (error) => {
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    getPoolTypes() {
      let context = this;
      services.GetPoolTypes().then(function (response) {
        context.poolTypes = response
        context.pooltypeId = context.poolTypes[0].PoolPoolTypeId
      }, (error) => {
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    togglePoolList() {

      this.isShowallpools = !this.isShowallpools
      var status = this.isShowallpools ? true : null;
      this.getPoolList(this.locationId, status)

    },
    ChangeStatus(item) {
      let context = this

      services.ChangePoolstatus(item.row.PoolId, !item.row.PoolIsActive).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
          loader.stopLoader()
          return;
        }

        context.getPoolList(context.locationId, true);
        context.$notify({
          title: 'Success',
          message: 'Status Changed Successfully',
          type: 'success'
        })
      }, (error) => {
        loader.stopLoader()
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    CreatePool(formName) {
      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addPool.PoolLocationId = this.poollocationId
          this.addPool.PoolPoolTypeId = this.pooltypeId
          if (context.addPool.PoolOpening != '' && context.addPool.PoolOpening != null) {
            var openingtime = new Date(context.addPool.PoolOpening)
            context.addPool.PoolOpening = (openingtime.getHours() < 10 ? '0' : '') + openingtime.getHours() + ":" + (openingtime.getMinutes() < 10 ? '0' : '') + openingtime.getMinutes()
          }
          if (context.addPool.PoolClosing != '' && context.addPool.PoolClosing != null) {
            var closingtime = new Date(context.addPool.PoolClosing)
            context.addPool.PoolClosing = (closingtime.getHours() < 10 ? '0' : '') + closingtime.getHours() + ":" + (closingtime.getMinutes() < 10 ? '0' : '') + closingtime.getMinutes()
          }
          loader.startLoader()

          if (context.isnewLocation == true) {
            context.addPool.PoolLocationId = ''
          } else {
            context.addPool.PoolLocationName = ''
          }
          services.CreatePool(this.addPool).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
              loader.stopLoader()
              return;
            }

            context.getPoolList(context.locationId, true);
            context.reintializeObject();
            loader.stopLoader()
            $('#Addpoolmodel').modal('hide')
            context.$notify({
              title: 'Success',
              message: 'Venue Created',
              type: 'success'
            }, (error) => {
              loader.stopLoader()
              context.$notify({
                title: 'Error',
                message: error.responseJSON.Message,
                type: 'error'
              })
            })
          })
        } else {
          loader.stopLoader()
          context.$notify({
            title: 'Error',
            message: 'Please enter required fields',
            type: 'error'
          })
        }
      })
    },
    UpdatePool(formName) {
      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addPool.PoolLocationId = this.poollocationId
          this.addPool.PoolPoolTypeId = this.pooltypeId
          if (context.addPool.PoolOpening != null) {
            var openingtime = new Date(context.addPool.PoolOpening)
            context.addPool.PoolOpening = (openingtime.getHours() < 10 ? '0' : '') + openingtime.getHours() + ":" + (openingtime.getMinutes() < 10 ? '0' : '') + openingtime.getMinutes()
          }
          if (context.addPool.PoolClosing != null) {
            var closingtime = new Date(context.addPool.PoolClosing)
            context.addPool.PoolClosing = (closingtime.getHours() < 10 ? '0' : '') + closingtime.getHours() + ":" + (closingtime.getMinutes() < 10 ? '0' : '') + closingtime.getMinutes()
          }
          loader.startLoader()

          if (context.isnewLocation == true) {
            context.addPool.PoolLocationId = ''
          } else {
            context.addPool.PoolLocationName = ''
          }
          services.UpdatePool(this.addPool).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
              loader.stopLoader()
              return;
            }
            context.getPoolList(context.locationId, true);
            context.reintializeObject();
            loader.stopLoader()
            context.isediting = false
            $('#Addpoolmodel').modal('hide')
            context.$notify({
              title: 'Success',
              message: 'Venue Updated',
              type: 'success'
            })
          }, (error) => {
            loader.stopLoader()
            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          loader.stopLoader()
          context.$notify({
            title: 'Error',
            message: 'Please enter required fields',
            type: 'error'
          })

        }
      })
    },
    ValidatePoolDetails(formname) {

      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {

        } else {

        }
      })

    },
    EditPool(item) {
      this.isediting = true
      this.isAddingOrEditing = "E"
      this.addPool = deepcopy(item.row)
      this.poollocationId = this.addPool.PoolLocationId
      var openingdate = new Date();
      if (this.addPool.PoolOpening != null) {
        openingdate.setHours(this.addPool.PoolOpening.split(':')[0]);
        openingdate.setMinutes(this.addPool.PoolOpening.split(':')[1]);
        this.addPool.PoolOpening = openingdate
      }
      var date = new Date()
      if (this.addPool.PoolClosing != null) {
        date.setHours(this.addPool.PoolClosing.split(':')[0]);
        date.setMinutes(this.addPool.PoolClosing.split(':')[1]);
        this.addPool.PoolClosing = date
      }
      this.showPopup('addPool')
    },
    handleCommand(item, command) {
      if (command == "edit")
        this.EditPool(item)
      else if (command == "archive")
        this.ChangeStatus(item)
      else if (command == "delete")
        this.DeletePool(item)

    },
    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    DeletePool(item){
      let context = this
      var poolid = item.row.PoolId
      var opts = {message: 'Are you sure you want to delete ' + item.row.PoolName + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deletePoolRow.bind(null,poolid))
    },
    deletePoolRow(poolid) {
      var context = this;
      loader.startLoader()
      services.DeletePool(poolid).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {   
          loader.stopLoader()
          return;
        }
        context.getPoolList(context.locationId, true);
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
        loader.stopLoader()
      },
      (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },

/*
    DeletePool(item) {
      alert('here I be');
      if(1==1) return;
      let context = this

      services.DeletePool(item.row.PoolId).then(function (response) {
        context.getPoolList(context.locationId, true);
        context.$notify({
          title: 'Success',
          message: 'Venue Deleted Successfully',
          type: 'success'
        })
      }, (error) => {
        loader.stopLoader()
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    */
    showNewLocation() {
      this.isnewLocation = true
    },
    addCurrentLocation() {
      this.isnewLocation = false
    },
    addPools(formName) {
      this.isediting = false
      this.isAddingOrEditing="A"
      this.reintializeObject()
      this.showPopup(formName)
    },
    CancelAddPool() {
      $('#Addpoolmodel').modal('hide')
      this.isadding = false
      this.isediting = false
      this.isAddingOrEditing=""
    },
    showPopup(formName) {

      let context = this
      context.buttonclicked = true
      this.isadding = true
      $('#Addpoolmodel').modal('show')
    },

    reintializeObject() {
      this.addPool.PoolName = ''
      this.addPool.PoolLocated = 'Indoor'
      this.addPool.PoolTypeDescription = ''
      this.addPool.PoolLanes = ''
      this.addPool.PoolStations = ''
      this.addPool.PoolShape = 'Rectangle'
      this.addPool.PoolVolume = ''
      this.addPool.PoolLength = ''
      this.addPool.PoolWidth = ''
      this.addPool.PoolLengthWidthUoM = 'Feet'
      this.addPool.PoolShalowMaxBathers = ''
      this.addPool.PoolDeepMaxBathers = ''
      this.addPool.PoolTotalMaxBathers = ''
      this.PoolMaxDepth = ''
      this.addPool.PoolMaxDepthUoM = ''
      this.addPool.PoolMinDepth = ''
      this.addPool.PoolMinDepthUoM = ''
      this.addPool.PoolVolume = ''
      this.addPool.PoolArea = ''
      this.addPool.PoolId = ''
      this.addPool.PoolPoolTypeId = ''
      this.addPool.PoolLocationId = ''
      this.addPool.PoolLocationName = ''
      this.addPool.PoolLocationAddress = ''
      this.addPool.PoolLocationPhoneNumber = ''
      this.addPool.PoolLocationFaxNumber = ''
      this.addPool.PoolVolumeUoM = ''
      this.addPool.PoolAreaUoM = ''
      this.addPool.PoolTurnOverTime = ''
      this.addPool.PoolTurnOverTime_Min = ''
      this.addPool.PoolTurnOverTime_Max = ''
      this.addPool.PoolTurnOverTime_UoM = ''
      this.addPool.PoolTurnOverPerDay = ''
      this.addPool.PoolTurnOverDayUoM = ''
      this.addPool.InfluentPressure = ''
      this.addPool.InfluentPressure_Min = ''
      this.addPool.InfluentPressure_Max = ''
      this.addPool.InfluentPressureUoM = ''
      this.addPool.EfluentPressure = ''
      this.addPool.EfluentPressure_Min = ''
      this.addPool.EfluentPressure_Max = ''
      this.addPool.EfluentPressureUoM = ''
      this.addPool.PoolCreatedOn = ''
      this.addPool.PoolUpdatedOn = ''
      this.addPool.UserName = ''
      this.addPool.OldUserName = ''
      this.addPool.PoolIsActive = ''
      this.addPool.PoolOpening = ''
      this.addPool.PoolClosing = ''
      this.addPool.SearchTag = ''
      this.addPool.PoolDescription = ''
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/Administration/ManagePools/ManagePools.controller.js